type ResourcesCounts = {
  human: number;
  material: number;
  virtual: number;
  inactive: number;
};

const resourcesCounts: ResourcesCounts = {
  human: 0,
  material: 0,
  virtual: 0,
  inactive: 0,
};

export type { ResourcesCounts };

export { resourcesCounts };
